import { useEffect } from 'react';
import { api } from '@/lib/api';

/**
 * Tiny no-render component that fetches site settings and applies
 * UI-affecting toggles (e.g. ALL CAPS class on <html>).
 * Re-polls every few minutes to catch admin edits without redeploy.
 */
export default function SiteSettingsApplier() {
  useEffect(() => {
    let active = true;
    const apply = (data) => {
      if (!active || !data) return;
      const root = document.documentElement;
      if (data.all_caps_enabled) root.classList.add('pg-all-caps');
      else root.classList.remove('pg-all-caps');
    };
    const fetchSettings = () => api.get('/settings').then(({ data }) => apply(data)).catch(() => {});
    fetchSettings();
    const id = setInterval(fetchSettings, 3 * 60 * 1000);
    return () => { active = false; clearInterval(id); };
  }, []);
  return null;
}
